export default {
  days: {
    0: "Domingo",
    1: "Lunes",
    2: "Martes",
    3: "Miércoles",
    4: "Jueves",
    5: "Viernes",
    6: "Sábado",
  },
  types: {
    habitual: "Habitual",
    occasional: "Ocasional",
    blocked: "Bloqueado",
  },
  appointmentTypes: {
    private: "Particular",
    insurance: "Obra Social",
  },
  consultationModes: {
    in_person: "Presencial",
    virtual: "Virtual",
    both: "Presencial y virtual",
  },
  consultationModeLabel: "Formato de consulta",
  consultationModeBothOption: "Ambas",
  consultationModeHint: "Si elegís \"Ambas\", el paciente o la secretaria eligen la modalidad al reservar.",
  consultationModeChoose: "Modalidad del turno *",
  consultationModeRequired: "Elegí si el turno es presencial o virtual",
  weekPrevious: "Semana anterior",
  weekNext: "Semana siguiente",
  weekOf: "Semana del",
};
